import styles from './index.module.css';
import langList from '../../utils/languagelist.json';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { serDownloadApk } from '../../axios';
import { Alert } from 'react-bootstrap';
import { saveAs } from 'file-saver';

export default function DownloadButton() {
  const [msgError, setMsgError] = useState('');
  const [isDownloading, setIsDownloading] = useState(false);
  const {lg}=useSelector((state)=>state.language);

  const handleDownload = () => {
    setIsDownloading(true);
    
    serDownloadApk((progressEvent) => {
      if (progressEvent.total) {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        setMsgError('1'+langList.download2[lg]+percentCompleted+'%');
      }
    })
    .then(blob => {
      saveAs(blob, 'ai-sudoku.apk');
      setIsDownloading(false);
      setMsgError('1'+langList.download3[lg]);
    })
    .catch(err => {
      setIsDownloading(false);
      setMsgError('0'+langList.download4[lg]);
    });
  };
  const chip=(
    <div className='pb-5 position-relative w-100'>
      <Alert 
        show={msgError!==''} 
        variant={msgError.substring(0,1)==='0'?'danger':'success'} 
        className='py-1 text-center text-danger position-absolute w-100'
      >
        {msgError.substring(1)}
      </Alert>
    </div>
  )
  if(msgError&&!isDownloading){
    setTimeout(() => {
      setMsgError('');
    }, 5000);
  };

  return (
    <div className={styles.download_container}>
      <button 
        onClick={handleDownload} 
        disabled={isDownloading}
        className={styles.download_btn}
      >
        <img src={'./pic/arrow-down-circle.svg'} alt='' className={styles.icon}/>
        {langList.download1[lg]}
      </button>
      <p>注：如下载失败，用Chrome浏览器重试</p>
      {chip}
    </div>
  );
};
